import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from "./context/ToastContext"; // ✅ added

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>  {/* ✅ Wrap your app globally */}
      <App />
    </ToastProvider>
  </React.StrictMode>
);

// Optional performance tracking
reportWebVitals();
